import { globalChannel } from "./globalChannel";
import { globalEventBus } from "infrastructure/globalEventBus";
import { TAB_ID } from "infrastructure/tabIdentity";

export function emit(domain, entity, action, scope = "local", payload) {
  const event = {
    domain,
    entity,
    action,
    payload,
    from: TAB_ID,
    ts: Date.now()
  };

  if (scope === "local" || scope === "both") {
    const name = `${domain}-${entity}-${action}`;
    globalEventBus.emit(name, event);
  }

  if (scope === "global" || scope === "both") {
    globalChannel.postMessage(event);
  }
}

export function on(domain, entity, action, handler) {
  const name = `${domain}-${entity}-${action}`;
  return globalEventBus.on(name, (event) => {
    if (event.domain === domain && event.entity === entity && event.action === action) {
      handler(event);
    }
  });
}